import { render, staticRenderFns } from "./RemarkListPopup.vue?vue&type=template&id=4ed2cc32&scoped=true&"
import script from "./RemarkListPopup.vue?vue&type=script&lang=js&"
export * from "./RemarkListPopup.vue?vue&type=script&lang=js&"
import style0 from "./RemarkListPopup.vue?vue&type=style&index=0&id=4ed2cc32&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2cc32",
  null
  
)

export default component.exports